import React from "react"
import { useStaticQuery, graphql } from "gatsby"

// Styles
import * as styles from "./HeaderStickers.module.scss"

const HeaderStickers = () => {
    const data = useStaticQuery(graphql`
        query HeaderQuery {
            wp {
                headerSettings {
                    header_small_cta_one {
                        options: ctaOneOptions {
                            text
                            link {
                                url
                                title
                                target
                            }
                        }
                    }
                    header_small_cta_two {
                        options: ctaTwoOptions {
                            text
                            link {
                                url
                                title
                                target
                            }
                        }
                    }
                }
            }
        }
    `)

    const cta = data.wp.headerSettings.header_small_cta_one
    const ctaTwo = data.wp.headerSettings.header_small_cta_two

    return (
        <>
            {cta.options.text && cta.options.link && (
                <div className={styles.Sticker}>
                    <a href={cta.options.link.url} dangerouslySetInnerHTML={{ __html: cta.options.text }}></a>
                </div>
            )}
            {ctaTwo.options.text && ctaTwo.options.link && (
                <div className={styles.Sticker}>
                    <a href={ctaTwo.options.link.url} dangerouslySetInnerHTML={{ __html: ctaTwo.options.text }}></a>
                </div>
            )}
        </>
    )
}

export default HeaderStickers
